import React from 'react';
import RadioInput from '../../../../Shared/RadioInput/RadioInput';

const SubscriberList = (props) => {
    return (<div className='subscriber-list-wrapper'>
        <div className='subscriber-list'>
            {props.subscribers?.map((subscriber, index) => {
                const subscriberKey = subscriber.subscriberNo ?? subscriber.ban;
                const isSelected = (props.selectedSubscriber?.subscriberNo ?? props.selectedSubscriber?.ban) == subscriberKey;
                const label = () => {
                    return (
                        <div className={`subscriber-package ${isSelected ? 'selected' : ''}`}>
                            <div className='title'>מנוי {window.Config.brand_Name_HE} TV</div>
                            <div className='email'>{subscriber.userTv}</div>
                            <div className='address'>{subscriber.address.fullAddress}</div>
                        </div>)
                }
                return (
                    <RadioInput
                        key={index}
                        checked={isSelected}
                        id={subscriberKey}
                        name='subscriber-package'
                        value={subscriberKey}
                        label={label()}
                        onChange={() => { props.onSelectedSubscriber(subscriber) }}
                    />
                )
            })}
        </div>
        {props.errorText && <div className='error-text'>{props.errorText}</div>}
    </div>);
};

export default SubscriberList;
